import {enableProdMode, provideZoneChangeDetection, ErrorHandler, importProvidersFrom} from "@angular/core";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";

import {myCustomTooltipDefaults} from "./app/app.module";
import {environment} from "./environments/environment";
import {DatePipe, CommonModule} from "@angular/common";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {MatPaginatorTranslator} from "./locale/MatPaginatorTranslator";
import {ClientErrorHandlerService} from "./app/core/services/services/client-error-handler.service";
import {MessageService} from "./app/core/services/services/message.service";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from "@angular/material/form-field";
import {DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from "@angular/material/core";
import {MondayMomentDateAdapter} from "./app/core/util/MondayMomentDateAdapter";
import {MEP_DATE_FORMATS_DEFAULT} from "./app/core/models/dateFormat";
import {MarkerService} from "./app/core/services/services/marker.service";
import {MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions, MatTooltipModule} from "@angular/material/tooltip";
import {MAT_SELECT_CONFIG, MatSelectModule} from "@angular/material/select";
import {MAT_AUTOCOMPLETE_DEFAULT_OPTIONS} from "@angular/material/autocomplete";
import {BrowserModule, bootstrapApplication} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AppRoutingModule} from "./app/app-routing.module";
import {CoreModule} from "./app/core/core.module";
import {OverlayModule} from "@angular/cdk/overlay";
import {MatDialogModule} from "@angular/material/dialog";
import {HttpClientModule} from "@angular/common/http";
import {SidenavModule} from "./app/shared/sidenav/sidenav.module";
import {ServiceWorkerModule} from "@angular/service-worker";
import {MatTableModule} from "@angular/material/table";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatSortModule} from "@angular/material/sort";
import {MatButtonToggleModule, MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS} from "@angular/material/button-toggle";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatInputModule} from "@angular/material/input";
import {MatMenuModule} from "@angular/material/menu";
import {AppComponent} from "./app/app.component";
import {provideHighcharts} from "highcharts-angular";

window.addEventListener("beforeinstallprompt", (event) => {
	// @ts-expect-error we are abusing the window object here because we need to intercept the event asap
	window.pwaEvent = event;
});

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	providers: [
		// Zone-based change detection (the app relies on Zone.js, see polyfills.ts/angular.json).
		// `eventCoalescing` batches multiple DOM events fired within the same tick (rapid mousemove,
		// scroll, keydown, etc.) into a single change-detection pass. Without it, every such event
		// triggers its own global CD over this large component tree — the main cause of the general
		// scroll/hover/typing lag in the Angular-21 build. Batching also reduces DOM churn, so DarkReader
		// re-themes less often. CD still runs (just coalesced), so it does not reintroduce stale-UI issues.
		provideZoneChangeDetection({eventCoalescing: true}),
		importProvidersFrom(
			CommonModule,
			BrowserModule,
			BrowserAnimationsModule,
			AppRoutingModule,
			CoreModule,
			OverlayModule,
			MatDialogModule,
			MatFormFieldModule,
			HttpClientModule,
			SidenavModule,
			ServiceWorkerModule.register("ngsw-worker.js", {
				enabled: environment.production,
				// Register the ServiceWorker as soon as the application is stable
				registrationStrategy: "registerWhenStable",
			}),
			MatTableModule,
			MatCheckboxModule,
			MatSelectModule,
			MatButtonModule,
			MatIconModule,
			MatTooltipModule,
			MatSortModule,
			MatButtonToggleModule,
			MatSidenavModule,
			MatProgressBarModule,
			MatInputModule,
			MatInputModule,
			MatMenuModule,
		),
		DatePipe,
		{provide: MatPaginatorIntl, useClass: MatPaginatorTranslator},
		{provide: ErrorHandler, useClass: ClientErrorHandlerService, deps: [MessageService]},
		{provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: "outline"}},
		{provide: DateAdapter, useClass: MondayMomentDateAdapter, deps: [MAT_DATE_LOCALE]},
		{provide: MAT_DATE_FORMATS, useValue: MEP_DATE_FORMATS_DEFAULT},
		MarkerService,
		{provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults},
		// Angular Material 21 (M3) shows a selection-indicator checkmark on selected mat-button-toggles by default,
		// which clips the fixed-width labels (e.g. the %/PT toggle). Selection is already conveyed via background color.
		{
			provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
			useValue: {hideSingleSelectionIndicator: true, hideMultipleSelectionIndicator: true},
		},
		{provide: MAT_SELECT_CONFIG, useValue: {overlayPanelClass: "mat-mdc-select-overlay-panel"}},
		{provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, useValue: {overlayPanelClass: "mat-mdc-autocomplete-overlay-panel"}},
		provideHighcharts({instance: () => import("highcharts").then(m => m.default)}),
	],
}).catch((err) => console.log(err));
